import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=334bb14f&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=334bb14f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334bb14f",
  null
  
)

export default component.exports